import { QueryResult, useQuery } from '@apollo/client';
import Config from '../../config';
import { StoreTypename } from '../../types';
import { Settings } from '../../types/enums';
import { findPriorityLicense } from '../selectors/license-selector';
import GET_ME from '../queries/me/get-me-query';

type User = any; // TODO: typing

export type UserStoreState = {
  me?: User;
  locale?: string;
  isAuthenticated: boolean;
  isAuthenticating: boolean;
};

export type UserStoreDispatch = {
  userRefetch: any;
};
export type UserStore = [UserStoreState, UserStoreDispatch];

export const getDefaultUserStoreState = (): any => ({
  __typename: StoreTypename.USER,
});

const useUserStore = (): UserStore => {
  const {
    data,
    loading,
    error,
    refetch: userRefetch,
  }: QueryResult<{ me: User }> = useQuery(GET_ME, {
    variables: {
      settingsWhere: { appId: 12 },
      toursSettingsWhere: { tours: [Settings.WELCOME], viewed: false },
      licensesWhere: { productFamily: { code: Config.productFamilyCode } },
    },
  });

  const isAuthenticated = data?.me && !error ? true : false;

  return [
    {
      ...(data && { me: { ...data.me, licenses: [findPriorityLicense(data.me.licenses)] } }),
      isAuthenticated,
      isAuthenticating: loading,
    },
    {
      userRefetch,
    },
  ];
};

export default useUserStore;
